import React from "react";
import './keyword-detail.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import CwContentViewer from "../../common/cw-content-viewer/cw-content-viewer";

class KeywordDetail extends React.Component {


    constructor(props) {
        super(props)

        this.state = {
            keywordDetail: this.props.keywordDetail
        }
    }


    toggleBack() {
        this.props.back && this.props.back()
    }




    render() {

        let content = this.state.keywordDetail

        return (
            <div className="keyword-detail">
                <div className='' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)}
                        onClick={() => this.toggleBack()} />
                </div>
                <div className="">
                    <div className='row align-items-center heading-wrapper mt-2 p-2'>
                        {/* <img className="case-study-bg" src={getImageSource(ImageConstants.ACTIVITY_BG)} /> */}
                        <div className='col-5 d-flex align-items-center'>
                            <div>
                                <img className='orange-play-icon mr-2' src={getImageSource(ImageConstants.DICTIONARY_IMAGE)} />
                            </div>
                            <div>
                                <div className="header-text">{`Dictionary`}</div>
                                {/* <div className=''>{this.renderBreadcrumb()}</div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="keyword-detail-wrapper mt-4">

                    <div className="heading text-center mb-4">{content.title}</div>

                    <div className="title mb-3">
                        {"Meaning"}
                    </div>
                    <div className="ml-2 mb-4">
                        <div className="">
                            <CwContentViewer content={content.meaning} />
                        </div>
                    </div>
                    <div className="title mb-3">
                        {"Examples"}
                    </div>
                    <div className="ml-2 mb-4">
                        <div className="examples">
                            <CwContentViewer content={content.examples} />
                        </div>
                    </div>
                    <div className="title mb-3">
                        {"Alternative Keywords"}
                    </div>
                    <div className="ml-2 mb-4">
                        {
                            content.alternateKeywordList && content.alternateKeywordList.length ?
                                content.alternateKeywordList.map((alternateKeyword, index) => (
                                    <span>{alternateKeyword.title}{`${index === content.alternateKeywordList.length - 1 ? "." : ", "}`} </span>
                                )) : <div className="text-center">No Alternate Keyword</div>
                        }
                        <div className="">

                        </div>
                    </div>
                    <div className="title mb-3">
                        {"Tips for Teachers"}
                    </div>
                    <div className="ml-2 ">
                        <div className="">
                            <CwContentViewer content={content.tipsforteachers} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default KeywordDetail;